var _g, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPfaLogoDark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1-2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 250,
    height: 98.57,
    viewBox: "0 0 250 98.57",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_61786",
    "data-name": "Group 61786"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61784",
    "data-name": "Group 61784",
    transform: "translate(62.897 60.16)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_82338",
    "data-name": "Path 82338",
    d: "M192.6,186.02H203.25a8.814,8.814,0,0,1,3.909.781,7.118,7.118,0,0,1,2.557,2.051,8.037,8.037,0,0,1,1.395,2.9,13.185,13.185,0,0,1,.421,3.318,10.733,10.733,0,0,1-.7,4.079,7.371,7.371,0,0,1-1.946,2.812,8.169,8.169,0,0,1-3.021,1.649,13.29,13.29,0,0,1-3.932.549h-3.256v12.051H192.59V186.02Zm6.088,13.654h2.707a4.013,4.013,0,0,0,2.939-1.1,4.626,4.626,0,0,0,1.12-3.426,5.293,5.293,0,0,0-.973-3.468,4,4,0,0,0-3.256-1.182h-2.538v9.174Z",
    transform: "translate(-192.59 -185.429)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_82339",
    "data-name": "Path 82339",
    d: "M256.08,186.02h5.836v9.765H262a5.9,5.9,0,0,1,5.539-2.916,5.756,5.756,0,0,1,4.291,1.522q1.5,1.524,1.5,4.948v16.868H267.5V200.52a3.905,3.905,0,0,0-.591-2.472,2.371,2.371,0,0,0-1.9-.7q-3.086,0-3.086,3.762v15.095H256.08Z",
    transform: "translate(-235.345 -185.429)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_82340",
    "data-name": "Path 82340",
    d: "M315.95,218.958a25.525,25.525,0,0,1,.464-5.157,9.955,9.955,0,0,1,1.522-3.743,6.765,6.765,0,0,1,2.769-2.283,10.088,10.088,0,0,1,4.206-.781,10.668,10.668,0,0,1,4.353.7,6.117,6.117,0,0,1,2.75,2.263,10.1,10.1,0,0,1,1.437,3.785,28.786,28.786,0,0,1,.421,5.222,25.343,25.343,0,0,1-.464,5.157,9.932,9.932,0,0,1-1.522,3.743,6.739,6.739,0,0,1-2.769,2.283,10.088,10.088,0,0,1-4.206.781,10.659,10.659,0,0,1-4.353-.7,6.117,6.117,0,0,1-2.75-2.263,10.094,10.094,0,0,1-1.437-3.762,28.659,28.659,0,0,1-.421-5.242Zm5.836,0q0,1.734.085,3.214a11.049,11.049,0,0,0,.4,2.538,3.743,3.743,0,0,0,.931,1.649,2.359,2.359,0,0,0,1.711.591,2.474,2.474,0,0,0,2.453-1.862,28.129,28.129,0,0,0,0-12.26,2.472,2.472,0,0,0-2.453-1.862,2.368,2.368,0,0,0-1.711.591,3.743,3.743,0,0,0-.931,1.649,11.049,11.049,0,0,0-.4,2.538C321.812,216.73,321.786,217.8,321.786,218.958Z",
    transform: "translate(-275.663 -199.552)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_82341",
    "data-name": "Path 82341",
    d: "M374.569,188.87H380.4v6.512h3.383v3.975H380.4v12.3a3.464,3.464,0,0,0,.4,1.924,1.948,1.948,0,0,0,1.669.572q.338,0,.676-.02c.225-.013.438-.036.634-.062v4.059q-.975.083-1.881.17c-.607.056-1.248.085-1.924.085a10.558,10.558,0,0,1-2.789-.3,3.1,3.1,0,0,1-1.626-.993,3.976,3.976,0,0,1-.784-1.839,16.235,16.235,0,0,1-.212-2.874V199.363H371.61v-3.975h2.959v-6.512Z",
    transform: "translate(-313.145 -187.348)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_82342",
    "data-name": "Path 82342",
    d: "M410.68,218.958a25.523,25.523,0,0,1,.464-5.157,9.955,9.955,0,0,1,1.522-3.743,6.765,6.765,0,0,1,2.769-2.283,10.088,10.088,0,0,1,4.206-.781,10.668,10.668,0,0,1,4.353.7,6.117,6.117,0,0,1,2.75,2.263,10.1,10.1,0,0,1,1.437,3.785,28.786,28.786,0,0,1,.421,5.222,25.345,25.345,0,0,1-.464,5.157,9.932,9.932,0,0,1-1.522,3.743,6.739,6.739,0,0,1-2.769,2.283,10.089,10.089,0,0,1-4.206.781,10.659,10.659,0,0,1-4.353-.7,6.117,6.117,0,0,1-2.75-2.263A10.1,10.1,0,0,1,411.1,224.2a28.659,28.659,0,0,1-.421-5.242Zm5.836,0q0,1.734.085,3.214a11.047,11.047,0,0,0,.4,2.538,3.743,3.743,0,0,0,.931,1.649,2.359,2.359,0,0,0,1.711.591,2.474,2.474,0,0,0,2.453-1.862,28.13,28.13,0,0,0,0-12.26,2.472,2.472,0,0,0-2.453-1.862,2.368,2.368,0,0,0-1.711.591,3.743,3.743,0,0,0-.931,1.649,11.047,11.047,0,0,0-.4,2.538C416.542,216.73,416.516,217.8,416.516,218.958Z",
    transform: "translate(-339.455 -199.552)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_82343",
    "data-name": "Path 82343",
    d: "M470.019,196.219H467.06v-3.975h2.959v-2.58a6.985,6.985,0,0,1,.421-2.58,4.06,4.06,0,0,1,1.205-1.692,4.8,4.8,0,0,1,1.924-.908,10.87,10.87,0,0,1,2.538-.274q1.523,0,3.129.127v4.144a3.088,3.088,0,0,0-.591-.042H478.1a2.754,2.754,0,0,0-1.734.421,1.716,1.716,0,0,0-.506,1.395v1.986h3.383v3.975h-3.383v18.772h-5.836V196.215Z",
    transform: "translate(-377.423 -184.21)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22886",
    "data-name": "Rectangle 22886",
    width: 5.575,
    height: 4.768,
    transform: "translate(103.263 0.558)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22887",
    "data-name": "Rectangle 22887",
    width: 5.836,
    height: 22.747,
    transform: "translate(103.263 8.034)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_82344",
    "data-name": "Path 82344",
    d: "M536.98,207.6h5.581v2.665h.085a5.913,5.913,0,0,1,2.41-2.472,7.113,7.113,0,0,1,3.383-.781,5.756,5.756,0,0,1,4.291,1.522q1.5,1.524,1.5,4.948v16.868H548.4V214.662a3.906,3.906,0,0,0-.591-2.472,2.371,2.371,0,0,0-1.9-.7q-3.086,0-3.086,3.762v15.095H536.98V207.6Z",
    transform: "translate(-424.508 -199.564)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_82345",
    "data-name": "Path 82345",
    d: "M608.6,213.8h-.085a6.43,6.43,0,0,1-2.178,2.306,5.88,5.88,0,0,1-2.982.7,5.722,5.722,0,0,1-5.284-2.812q-1.69-2.812-1.692-9.154t1.692-9.154a5.726,5.726,0,0,1,5.284-2.812,5.507,5.507,0,0,1,2.812.676,6.641,6.641,0,0,1,2.093,2.028h.085V186.02h5.836v30.186H608.6V213.8Zm-6.385-8.961a20.512,20.512,0,0,0,.572,5.6,2.384,2.384,0,0,0,2.472,1.881,2.428,2.428,0,0,0,2.515-1.881,27.73,27.73,0,0,0,0-11.2,2.407,2.407,0,0,0-2.515-1.881,2.362,2.362,0,0,0-2.472,1.881A20.528,20.528,0,0,0,602.216,204.838Z",
    transform: "translate(-464.509 -185.429)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_61785",
    "data-name": "Group 61785"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_82346",
    "data-name": "Path 82346",
    d: "M65.712,26.793v6.143H38.589a5.654,5.654,0,0,0-5.656,5.653v27.2H0v-39A26.793,26.793,0,0,1,26.793,0H38.922A26.793,26.793,0,0,1,65.715,26.793",
    fill: "#6711ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_82347",
    "data-name": "Path 82347",
    d: "M32.933,201.44v5.99A26.8,26.8,0,0,1,6.14,234.222H1.476A1.475,1.475,0,0,1,0,232.746v-31.3H32.933Z",
    transform: "translate(0 -135.653)",
    fill: "#00b1ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_82348",
    "data-name": "Path 82348",
    d: "M133.612,100.84v5.99a26.8,26.8,0,0,1-26.793,26.793h-5.99V106.493a5.656,5.656,0,0,1,5.656-5.653h27.123Z",
    transform: "translate(-67.901 -67.907)",
    fill: "#00eaaf"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_82349",
    "data-name": "Path 82349",
    d: "M664.995,257.74v6.767H659.27V257.74Z",
    transform: "translate(-443.963 -173.566)",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_82350",
    "data-name": "Path 82350",
    d: "M685.43,182.58h5.986V187.7H685.43Zm0,7.978h5.986V213.89H685.43Z",
    transform: "translate(-461.58 -122.952)",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_82351",
    "data-name": "Path 82351",
    d: "M711.313,205.767h5.725V208.5h.088a6.083,6.083,0,0,1,2.472-2.538,7.3,7.3,0,0,1,3.468-.8,5.91,5.91,0,0,1,4.4,1.561q1.538,1.563,1.538,5.075v17.3h-5.986V213.008a4,4,0,0,0-.607-2.538,2.427,2.427,0,0,0-1.953-.715q-3.165,0-3.165,3.86V229.1H711.31V205.767Z",
    transform: "translate(-479.008 -138.158)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPfaLogoDark);
export default __webpack_public_path__ + "static/media/pfa_logo_dark..63716ded6ed790a89a825875d9f63a49.svg";
export { ForwardRef as ReactComponent };